import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable()
export class PRMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams): string {
        const keys = JSON.parse( localStorage.getItem('missing-keys') || '{}' );
        
        const idx = params.key.indexOf( '.' );
        if (idx !== -1) {
            const prefix = params.key.substr( 0, idx );
            const value = params.key.substr( idx + 1);
            const obj = keys[prefix] || {};
            obj[value] = '';
            keys[prefix] = obj;

        } else {
            keys[params.key] = '';
        }
        
        localStorage.setItem('missing-keys', JSON.stringify( keys, null, 2 ));
        return params.key;
    }

    constructor() {
        localStorage.setItem('missing-keys', '');
    }
}